export default function () {
  return {
    bans: [],
    bansCurrentPage: 1,
    bansLastPage: 1,
    bansPerPage: 0,
    bansTotal: 0,
    bansLoading: false,
    indexPage: null,
    search: ''
  }
}
